module.exports = __webpack_public_path__ + "img/question.a3091faa.png";